import SiteContentEditor from "./SiteContentEditor";

const PrivacyPolicyContent = () => (
  <SiteContentEditor slug="privacy-policy" heading="Privacy Policy" />
);

export default PrivacyPolicyContent;
